/**
 * DOM Utility Functions
 * Extracted from main.js for reusability across the project
 */

// Helper functions for class manipulation
export function toggleClass(el, className) {
  if (el) el.classList.toggle(className);
}

export function addClass(el, className) {
  if (el) el.classList.add(className);
}

export function removeClass(el, className) {
  if (el) el.classList.remove(className);
}

export function hasClass(el, className) {
  return el ? el.classList.contains(className) : false;
}

// Additional DOM utilities
export function show(el) {
  if (el) el.style.display = "block";
}

export function hide(el) {
  if (el) el.style.display = "none";
}

export function toggle(el) {
  if (el) {
    el.style.display = el.style.display === "none" ? "block" : "none";
  }
}
